import isEmpty from 'lodash/isEmpty';

const today = new Date().toISOString().split('T')[0];
const fastDate = getPastDate(3);
const futureDates = getFutureDates(12);
const dates = [fastDate, today].concat(futureDates);

function getFutureDates(numberOfDays: number) {
  const array: string[] = [];
  for (let index = 1; index <= numberOfDays; index++) {
    let d = Date.now();
    if (index > 8) {
      // set dates on the next month
      const newMonth = new Date(d).getMonth() + 1;
      d = new Date(d).setMonth(newMonth);
    }
    const date = new Date(d + 864e5 * index); // 864e5 == 86400000 == 24*60*60*1000
    const dateString = date.toISOString().split('T')[0];
    array.push(dateString);
  }
  return array;
}
function getPastDate(numberOfDays: number) {
  return new Date(Date.now() - 864e5 * numberOfDays).toISOString().split('T')[0];
}

export const agendaItems = [
  {
    title: dates[0],
    data: [{duration: '3d', owner_code: 'TRW', due_date: dates[0], task_name: 'Kitchen demolition'}]
  },
  {
    title: dates[1],
    data: [
      {duration: '1h',  owner_code: 'TRW', task_name: 'Kitchen cabinets install'},
      {duration: '1h',  owner_code: 'MEL', task_name: 'Bathroom demolition'}
    ]
  },
  {
    title: dates[2],
    data: [
      { duration: '1h',  owner_code: 'TRW', task_name: 'Kitchen tile'},
      { duration: '1h',  owner_code: 'MEL', task_name: 'Bathroom tile'},
      { duration: '1h',  owner_code: 'MEL', task_name: 'Bathroom sink'}
    ]
  },
  {
    title: dates[3],
    data: [{duration: '1h',  owner_code: 'TRW', task_name: 'Kitchen tile'}]
  },
  {
    title: dates[4],
    data: [{}]
  },
  {
    title: dates[5],
    data: [
      {hour: '9pm', duration: '1h',owner_code: 'MEL', task_name: 'Kitchen cabinets install'},
      {hour: '10pm', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen tile'},
      {hour: '11pm', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen floor'},
      {hour: '12pm', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen counters'}
    ]
  },
  {
    title: dates[6], 
    data: [
      {hour: '12am', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen tile'}
    ]
  },
  {
    title: dates[7], 
    data: [{}]
  },
  {
    title: dates[8],
    data: [
      {hour: '9pm', duration: '1h', owner_code: 'MEL', task_name: 'Appliances'},
      {hour: '10pm', duration: '1h', owner_code: 'MEL',  task_name: 'Kitchen tile'},
      {hour: '11pm', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen floor'},
      {hour: '12pm', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen counters'}
    ]
  },
  {
    title: dates[9],
    data: [
      {hour: '1pm', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen tile'},
      {hour: '2pm', duration: '1h', owner_code: 'MEL', task_name: 'Bathroom tile'},
      {hour: '3pm', duration: '1h', owner_code: 'MEL', task_name: 'Bathroom sink'}
    ]
  },
  {
    title: dates[10], 
    data: [
      {hour: '12am', duration: '1h', owner_code: 'MEL', task_name: 'Kitchen paint'}
    ]
  },
  {
    title: dates[11],
    data: [
      {duration: '1h', owner_code: 'MEL', task_name: 'Kitchen tile'},
      {duration: '1h', owner_code: 'MEL', task_name: 'Bathroom tile'},
      {duration: '1h', owner_code: 'MEL', task_name: 'Bathroom sink'}
    ]
  },
  {
    title: dates[12], 
    data: [
      {duration: '1h', owner_code: 'MEL', task_name: 'Bathroom paint'}
    ]
  },
  {
    title: dates[13], 
    data: [
      {duration: '1h', owner_code: 'MEL', task_name: 'Bathroom paint'}
    ]
  }
];

export function getMarkedDates() {
  const marked = {};

  agendaItems.forEach(item => {
    // NOTE: only mark dates with data
    if (item.data && item.data.length > 0 && !isEmpty(item.data[0])) {
      marked[item.title] = {marked: true};
    } else {
      marked[item.title] = {disabled: true};
    }
  });
  return marked;
}
